import script from "./QuestionnairesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionnairesPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionnairesPage.vue?vue&type=style&index=0&id=581576d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581576d1"]])

export default __exports__